import { render, staticRenderFns } from "./bonus_coupon_detail.vue?vue&type=template&id=105b75f1&scoped=true&"
import script from "./bonus_coupon_detail.vue?vue&type=script&lang=js&"
export * from "./bonus_coupon_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b75f1",
  null
  
)

export default component.exports